const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : '/api');

const getToken = () => localStorage.getItem('auth-token');
const isGuest = () => localStorage.getItem('auth-token') === 'guest-token';

const apiCall = async (endpoint, options = {}) => {
  if (isGuest()) {
    throw new Error('This feature requires login');
  }

  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Request failed');
  }

  return response.json();
};

export const login = async (email, password) => {
  const response = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Login failed');
  }

  return response.json();
};

export const getUsers = () => apiCall('/users');
export const createUser = (user) => apiCall('/users', { method: 'POST', body: JSON.stringify(user) });
export const updateUser = (id, user) => apiCall(`/users/${id}`, { method: 'PUT', body: JSON.stringify(user) });
export const deleteUser = (id) => apiCall(`/users/${id}`, { method: 'DELETE' });

export const getSpecs = () => apiCall('/specs');
export const createSpec = (spec) => apiCall('/specs', { method: 'POST', body: JSON.stringify(spec) });
export const updateSpec = (id, metadata) => apiCall(`/specs/${id}`, { method: 'PUT', body: JSON.stringify(metadata) });
export const deleteSpec = (id) => apiCall(`/specs/${id}`, { method: 'DELETE' });

export const getSpecVersions = (specId) => apiCall(`/specs/${specId}/versions`);
export const createSpecVersion = (specId, version) => apiCall(`/specs/${specId}/versions`, { method: 'POST', body: JSON.stringify(version) });
export const updateSpecVersion = (specId, versionId, content) => apiCall(`/specs/${specId}/versions/${versionId}`, { method: 'PUT', body: JSON.stringify({ content }) });
export const updateVersionStatus = (specId, versionId, status) => apiCall(`/specs/${specId}/versions/${versionId}/status`, { method: 'PUT', body: JSON.stringify(status) });
export const deleteSpecVersion = (specId, versionId) => apiCall(`/specs/${specId}/versions/${versionId}`, { method: 'DELETE' });

export const getPublicSpec = async (title, version) => {
  const response = await fetch(`${API_URL}/public/specs/${title}/${version}`);
  if (!response.ok) throw new Error('Spec not found or not public');
  return response.json();
};

export const getSSOConfig = () => apiCall('/sso/config');
export const createSSOConfig = (config) => apiCall('/sso/config', { method: 'POST', body: JSON.stringify(config) });

export const validateSpec = (spec, format) => apiCall('/validate', { method: 'POST', body: JSON.stringify({ spec, format }) });

export const getRulesConfig = () => apiCall('/rules-config');
export const updateRulesConfig = (config) => apiCall('/rules-config', { method: 'PUT', body: JSON.stringify(config) });
